"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Popup = _interopRequireDefault(require("../../../components/Popup"));

var _default = function _default(_ref) {
  var className = _ref.className,
      children = _ref.children,
      content = _ref.content,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "content"]);
  return /*#__PURE__*/_react["default"].createElement(_Popup["default"], (0, _extends2["default"])({
    className: "cloud-ui-nav-popup ".concat(className),
    positionFixed: true,
    size: "small",
    popperModifiers: [{
      name: 'preventOverflow',
      options: {
        boundariesElement: 'offsetParent'
      }
    }],
    content: /*#__PURE__*/_react["default"].createElement(_Popup["default"].Content, {
      content: content
    }, children)
  }, props));
};

exports["default"] = _default;